import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby';
import { ReactSVG } from 'react-svg';

import FacebookIcon from '../images/Footer-FB.svg';
import InstaIcon from '../images/Footer-IG.svg';
import PinterestIcon from '../images/pinterest.svg';
import TikTokIcon from '../images/Footer-TikTok.svg';
import YoutubeIcon from '../images/Footer-YouTube.svg';

const Footer = () => {

  return (
    <footer className='no-print'>
      <div className='bg-dorot-purple pt-14 px-7.5 1024:px-12.5 lg:px-18 pb-8'>
        <div className='grid grid-cols-1 1024:grid-cols-2 lg:grid-cols-3'>
          <div>
            <div>
              <Link to='/'>
                <StaticImage src='../images/dorot-footer.png' alt='Footer' className='w-32 1024:w-52 lg:w-64 h-full' />
              </Link>
            </div>
            <div className='1024:max-w-sm lg:max-w-xs'>
              <p className='text-white pt-7 1024:pt-5 text-_1625 font-goldplay font-semibold'>Our flash-frozen pre-portioned garlic, onions and herb packs give you all of the flavor of fresh ingredients, but without the pesky chopping and measuring.</p>
            </div>
            <div className='text-_2032 font-bold text-white font-goldplay 1024:pt-4 hidden 1024:block lg:hidden'>Quick Links</div>
            <div className='max-w-md text-white pt-5 hidden 1024:block lg:hidden'>
              <div className='grid grid-cols-3'>
                <div><Link to='/products' className='font-goldplay font-semibold'>Products</Link></div>
                <div><Link to='/recipes' className='font-goldplay font-semibold'>Recipes</Link></div>
                <div><Link to='/cooking-classes' className='font-goldplay font-semibold'>Cooking Classes</Link></div>
                <div><Link to='/blog' className='font-goldplay font-semibold'>Blog</Link></div>
              </div>
              <div className='grid grid-cols-3 pt-5 font-goldplay'>
                <div><Link to='/faq' className='font-goldplay font-semibold'>FAQs</Link></div>
                <div><Link to='/about-us' className='font-goldplay font-semibold'>Our Story</Link></div>
                <div><Link to='/where-to-find' className='font-goldplay font-semibold'>Where To Find Us</Link></div>
              </div>
            </div>
          </div>
          <div className='lg:flex justify-center 1024:hidden'>
            <div>
              <div className='text-_2032 font-bold text-white font-goldplay hidden 1024:block'>Quick Links</div>
              <div className='grid grid-cols-2 text-white pt-10 1024:pt-5'>
                <div className='space-y-5'>
                  <div><Link to='/products' className='font-goldplay font-semibold'>Products</Link></div>
                  <div><Link to='/recipes' className='font-goldplay font-semibold'>Recipes</Link></div>
                  <div><Link to='/cooking-classes' className='font-goldplay font-semibold'>Cooking Classes</Link></div>
                  <div><Link to='/blog' className='font-goldplay font-semibold'>Blog</Link></div>
                </div>
                <div className='space-y-5 font-goldplay'>
                  <div><Link to='/faq' className='font-goldplay font-semibold'>FAQs</Link></div>
                  <div><Link to='/about-us' className='font-goldplay font-semibold'>Our Story</Link></div>
                  <div><Link to='/where-to-find' className='font-goldplay font-semibold'>Where To Find Us</Link></div>
                </div>
              </div>
              <Link to='/contact-us' className='text-_2032 font-bold text-white pt-14 font-goldplay hidden 1024:block'>Contact Us</Link>
              <div className='max-w-xs text-white pt-5 hidden 1024:block'>
                <div className='space-y-5 font-goldplay'>
                  <div><a href='https://www.google.com/maps/place/72+New+Hook+Rd,+Bayonne,+NJ+07002,+USA/@40.6595583,-74.1070016,17z/data=!3m1!4b1!4m6!3m5!1s0x89c251e6c3bbd9d1:0x70aef159a14389e5!8m2!3d40.6595583!4d-74.1044267!16s%2Fg%2F11gmfrlslh?entry=ttu' className='flex items-center text-_1625 gap-2 font-semibold'><StaticImage src='../images/pin-loc.svg' alt='Footer' className='w-5 h-full' /><span className='font-goldplay'>72 New Hook Rd., Bayonne, NJ 07002</span></a></div>
                  <div><a href='mailto:info@dorotgardens.com' className='flex items-center text-_1625 gap-2'><StaticImage src='../images/email.svg' alt='Footer' className='w-5 h-full' /><span className='font-goldplay font-semibold'>info@dorotgardens.com</span></a></div>
                  <div><a href='tel:718-369-4600' className='flex items-center text-_1625 gap-2'><StaticImage src='../images/phone.svg' alt='Footer' className='w-5 h-full' /><span className='font-goldplay font-semibold'>718-369-4600</span></a></div>
                </div>
              </div>
            </div>
          </div>
          <div className='pt-12.5 1024:pt-0 1024:pl-12.5 lg:pl-0'>
            <div className='text-_2032 font-bold text-white font-goldplay'>Let's Get Social</div>
            <div className='max-w-xs'>
              <p className='text-white text-_1625 pt-3 font-goldplay font-semibold'>Find inspiring recipes, see exciting updates and share your dishes with us! </p>
            </div>
            <div className='pt-7.5 1024:pt-5 flex space-x-2 mb-9 1024:mb-0'>
              <a href='https://www.facebook.com/DorotGardens/' className='border_ border-solid border-white p-2.5 rounded-full'>
                <span>
                  <ReactSVG
                    beforeInjection={(svg) => {
                      svg.classList.add('footer-fb-icon')
                      svg.setAttribute('width', '')
                      svg.setAttribute('height', '')
                      svg.setAttribute('alt', 'Facebook')
                    }}
                    className='md:w-15 md:h-15'
                    src={FacebookIcon} />
                  {/* <StaticImage src='../images/facebook_img.svg' alt='Facebook' className='object-cover w-7 h-7 1024:w-10 1024:h-10' /> */}
                </span>
              </a>
              <a href='https://www.instagram.com/dorotgardens/' className='border_ border-solid border-white p-2.5 rounded-full'>
                <span>
                  <ReactSVG
                    beforeInjection={(svg) => {
                      svg.classList.add('footer-insta-icon')
                      svg.setAttribute('width', '')
                      svg.setAttribute('height', '')
                      svg.setAttribute('alt', 'Instagram')
                    }}
                    className='md:w-15 md:h-15'
                    src={InstaIcon} />
                  {/* <StaticImage src='../images/instagram_img.svg' alt='Instagram' className='object-cover w-7 h-7 1024:w-10 1024:h-10' /> */}
                </span>
              </a>
              <a href='https://www.tiktok.com/@dorotgardens' className='border_ border-solid border-white p-2.5 rounded-full'>
                <span>
                  <ReactSVG
                    beforeInjection={(svg) => {
                      svg.classList.add('footer-tiktok-icon')
                      svg.setAttribute('width', '')
                      svg.setAttribute('height', '')
                      svg.setAttribute('alt', 'Tiktok')
                    }}
                    className='md:w-15 md:h-15'
                    src={TikTokIcon} />
                  {/* <StaticImage src='../images/tiktok_img.svg' alt='Tiktok' className='object-cover w-7 h-7 1024:w-10 1024:h-10' /> */}
                </span>
              </a>
              <a href='https://www.youtube.com/@DorotGardens-FreshFrozenHe-k4h' className='border_ border-solid border-white p-2.5 rounded-full'>
                <span>
                  <ReactSVG
                    beforeInjection={(svg) => {
                      svg.classList.add('footer-youtube-icon')
                      svg.setAttribute('width', '')
                      svg.setAttribute('height', '')
                      svg.setAttribute('alt', 'Youtube')
                    }}
                    className='md:w-15 md:h-15'
                    src={YoutubeIcon} />
                  {/* <StaticImage src='../images/youtube_img.svg' alt='Youtube.com' className='object-cover w-7 h-7 1024:w-10 1024:h-10' /> */}
                </span>
              </a>
              {/* <a href='https://www.pinterest.com/mydorotgardens/' className='lg:hidden_ border_ border-solid border-white p-2.5 rounded-full'>
                <span>
                  <ReactSVG 
                    beforeInjection={(svg) => {
                      svg.classList.add('footer-pinterest-icon')
                      svg.setAttribute('width', '')
                      svg.setAttribute('height', '')
                      svg.setAttribute('alt', 'Pinterest')
                    }}
                     className='md:w-15 md:h-15'
                    src={PinterestIcon} />
                
                </span>
                </a> */}
            </div>
            <Link to='/contact-us' className='text-_2032 font-bold text-white pt-9 1024:pt-7 lg:pt-14 font-goldplay 1024:block lg:hidden'>Contact Us</Link>
            <div className='max-w-xs text-white pt-5 1024:block lg:hidden'>
              <div className='space-y-5 font-goldplay'>
                <div className='flex items-center text-_1625'><a href='https://www.google.com/maps/place/72+New+Hook+Rd,+Bayonne,+NJ+07002,+USA/@40.6595583,-74.1070016,17z/data=!3m1!4b1!4m6!3m5!1s0x89c251e6c3bbd9d1:0x70aef159a14389e5!8m2!3d40.6595583!4d-74.1044267!16s%2Fg%2F11gmfrlslh?entry=ttu' className='space-x-2'><StaticImage src='../images/pin-loc.svg' alt='Footer' className='w-5 h-full' /><span>72 New Hook Rd., Bayonne, NJ 07002</span></a></div>
                <div className='flex items-center text-_1625 space-x-2'><a href='mailto:info@dorotgardens.com' className='space-x-2'><StaticImage src='../images/email.svg' alt='Footer' className='w-5 h-full' /><span>info@dorotgardens.com</span></a></div>
                <div className='flex items-center text-_1625 space-x-2'><a href='tel:718-369-4600' className='space-x-2'><StaticImage src='../images/phone.svg' alt='Footer' className='w-5 h-full' /><span>718-369-4600</span></a></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr className='border border-flavour-8' />
      <div className='bg-dorot-purple px-7.5 1024:px-0 1024:flex 1024:justify-center py-6'>
        <div className='grid grid-rows-3 font-goldplay grid-flow-col 1024:flex 1024:space-x-9 text-_1425'>
          <a href="/privacy-policy" className='text-color-gray font-semibold'>Privacy Policy</a>
          <a href="/terms-of-use" className='text-color-gray pt-4 1024:pt-0 font-semibold'>Terms of Use</a>
          {/* <a className='text-color-gray pt-5 1024:pt-0'>Sustainability</a>
          <a className='text-color-gray'>Compliance Item 1</a>
          <a className='text-color-gray pt-4 1024:pt-0'>Compliance Item 2</a> */}
        </div>
      </div>
    </footer>
  )

}

export default Footer;